export default () => {
  // if( window.location.host.indexOf( 'localhost' ) !== -1 ) {
  //   return 'https://ark-api-staging.proof-point-suite.com';
  // } else if( window.location.host.indexOf( 'cockpit-staging.proof-point-suite.com' ) !== -1 ) {
  //   return 'https://ark-api-staging.proof-point-suite.com';
  // } else if( window.location.host.indexOf( 'cockpit-staging2.proof-point-suite.com' ) !== -1 ) {
  //   return 'https://ark-api-staging.proof-point-suite.com';
  // } else if( window.location.host.indexOf( 'cockpit-staging4.proof-point-suite.com' ) !== -1 ) {
  //   return 'https://ark-api-staging4.proof-point-suite.com';
  // } else if( window.location.host.indexOf( 'cockpit-staging5.proof-point-suite.com' ) !== -1 ) {
  //   return 'https://ark-api-staging5.proof-point-suite.com';
  // } else if( window.location.host.indexOf( 'adminportal.aciso-suite.com' ) !== -1 ) {
  //   return 'https://ark-api.aciso-suite.com';
  // } else if( window.location.host.indexOf( 'adminportal.tennis-suite.com' ) !== -1 ) {
  //   return 'https://ark-api.tennis-suite.com';
  // }
  return 'https://ark-api-staging.proof-point-suite.com'
}
